module.exports = __webpack_public_path__ + "img/16l008-03.bda8427e.jpg";